import React, { Component } from 'react';
import { AddReviewForm } from "../Components/Forms"
import { NormalButton } from "../Components/Buttons"
import ButtonGroup from 'react-bootstrap/ButtonGroup';
class AddReview extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isVisible: false
        }
    }

    fadeIn() {
        setTimeout( () => {
            this.setState({isVisible : true});
        }, 0)        
    }
    componentDidMount() {
        this.fadeIn();
    }
    render () {
        return (
            <div className="AddReview">
                <div className="Home">
                    <div >
                        <h1 className="Home-Title">The Cafe Log</h1>
                    </div>

                    <div>
                        <p className="Home-Para">A compilation of every cafe visited, with expert analysis on each.</p>
                    </div>
                    
                </div>
                <div className="Home-Options">
                    <ButtonGroup>
                        <NormalButton link="/" text="Back to Home"></NormalButton>
                        <NormalButton link="/viewreview" text="View all reviews"></NormalButton>
                    </ButtonGroup>
                </div>
                <div className="Home-Under">
                    <div>
                        <p className="Home-Para2">Add your review below!</p>
                    </div>
                </div>
                <div className="AddReview-Form-Outer">
                    <AddReviewForm></AddReviewForm>
                </div>
            </div>
        );
    };
};

export default AddReview;